<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <h3>{{ data?.header | translate }}</h3>
  <div class="form-group">
    <p>{{ data?.description | translate }}</p>
  </div>
  <div class="form-group">
    <label for="userName">{{ "i18n.base.login.userName" | translate }}</label>
    <input id="userName" type="text" class="form-control" placeholder="{{ 'i18n.base.login.userName' | translate }}"
      formControlName="userName">
    <app-error-messages [control]="form.controls.userName"></app-error-messages>
  </div>
  <div class="form-group">
    <label for="password">{{ "i18n.base.login.password" | translate }}</label>
    <input id="password" type="password" class="form-control" placeholder="{{ 'i18n.base.login.password' | translate }}" formControlName="password" appPasswordVisibility>
    <app-error-messages [control]="form.controls.password"></app-error-messages>
  </div>
  <button type="submit" class="btn btn-primary btn-right" [disabled]="loading">
    {{ "i18n.base.two-factor-authentication.registration.get-code" | translate }}
  </button>
  @if (data?.linkRoute) {
    <a class="btn btn-link btn-right" [routerLink]="[data.linkRoute]">
      {{ data.linkLabel| translate }}
    </a>
  }
</form>
